var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 121,
    height: 121,
    fill: "#C9A662"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_260_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.5884 9.43113C66.8721 17.2205 70.0467 27.5266 64.3308 37.9719C61.2848 43.5393 56.4182 47.2334 55.5491 53.9256C53.5585 69.2735 68.1123 77.2037 67.5318 91.6738C67.479 92.974 67.1921 94.3854 67.0387 95.6823H66.5472C66.5258 95.2828 66.5934 94.8701 66.5291 94.4722C64.5336 82.0145 53.9873 78.2222 47.2456 69.1818C41.3812 61.3187 37.8273 51.8641 41.6681 42.2457C44.005 36.3902 48.7661 31.879 52.0512 26.5769C55.521 20.9735 57.81 14.7283 56.5204 8.05076C56.8816 7.71672 58.2702 9.13148 58.5884 9.43113Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9851 46.7159C71.902 55.866 80.8108 62.5975 84.5824 70.4688C90.4451 82.7087 85.0425 96.144 74.8441 104.015C72.6425 105.715 69.9033 107.436 67.2053 108.107C67.0337 107 68.1634 106.265 68.7884 105.35C73.8728 97.8961 74.7089 85.7626 70.9868 77.6162C69.6147 74.6164 67.4032 72.5041 65.7622 69.7335C63.1863 65.3845 62.1028 61.1222 62.4409 56.0379C62.8383 50.053 66.7204 45.1963 70.6586 40.993L70.9868 41.1584C71.117 42.9465 70.8103 44.9589 70.9868 46.7175L70.9851 46.7159Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0662 66.9073C41.2608 69.8187 42.5636 72.604 44.221 74.9685C50.1761 83.4619 64.1889 89.3404 62.0599 101.6C61.3442 105.718 58.5192 109.506 55.1895 111.934C54.9257 112.126 53.7993 112.933 53.608 112.98C52.7455 113.196 53.3804 111.512 53.4018 110.974C53.6591 104.579 47.7865 101.839 43.6949 98.217C40.9112 95.7527 37.1841 91.3627 36.3727 87.6784C35.2216 82.45 36.7949 71.7656 40.273 67.5066C40.4774 67.2561 40.6836 66.8631 41.0662 66.9073Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_260_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 105,
    fill: "white",
    transform: "translate(36 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause1);
export default __webpack_public_path__ + "static/media/pause1.d954caa04e3559ac5ef96cd960e02fe8.svg";
export { ForwardRef as ReactComponent };